import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { CloseButton } from '../../ui-kit/DialogManager/CloseButton.js';
import { useDialogManager } from '../../ui-kit/DialogManager/useDialogManager.js';
import { style } from '../../utils/style.js';
export const StickyBottomMenuDialog = JSX(({ className, head, children, onClose, onClick }) => {
    const { close } = useDialogManager();
    const handleClose = useCallback(() => {
        close();
        onClose && onClose();
    }, [onClose]);
    return (_jsxs("div", { onClick: onClick, className: style('relative min-h-full bg-white p-0 rounded-xl top-32', className), role: "dialog", children: [_jsxs("div", { className: "sticky py-xl top-0 rounded-xl bg-white z-10", children: [_jsx(CloseButton, { className: "absolute top-1.5 right-0", onClose: handleClose }), _jsx("div", { className: "container", children: head })] }), _jsx("div", { className: "container pb-6xl", children: children })] }));
});
//# sourceMappingURL=StickyBottomMenuDialog.js.map